import React, { useState } from "react"
import { NETWORK_ID_TIER_MAPPING } from "../../utils/networkIdMapping"
import { ProviderTypeTags } from "./ProviderTypeTags"
import { tierForModalProps, TierInfoModal } from "./TierInfoModal"
import { FormattedMessage } from "react-intl"
import { Benefit } from "pages/provider-finder/types/Benefit"
import { Box, Chip, InfoIcon, Link, Stack } from "@carrotfertility/carotene-core"
import { Theme } from "@mui/system"

export function ProviderTypeTagsForExtendedNetworks({
  parentIds,
  providerTypeIds,
  networkIds,
  benefit
}: {
  parentIds: number[]
  providerTypeIds: number[]
  networkIds: number[]
  benefit: Benefit
}): JSX.Element {
  const [open, setOpen] = useState(false)
  const [tierForModal, setTierForModal] = useState<tierForModalProps>(null)

  const providerTierTags = networkIds.map((networkId, i) => {
    // @ts-expect-error TS7053
    const providerTier = NETWORK_ID_TIER_MAPPING[networkId]

    if (providerTier) {
      return (
        <Link
          component="button"
          key={i}
          onClick={() => {
            setOpen(true)
            setTierForModal(providerTier)
          }}
        >
          <Chip
            size="small"
            key={i}
            label={
              <Box display="flex" flexDirection="row" alignItems="center">
                <FormattedMessage {...providerTier.tierDisplayName} />
                &nbsp;
                <InfoIcon color="inherit" fontSize="inherit" />
              </Box>
            }
            sx={(theme: Theme): { backgroundColor: any; color: any } => ({
              backgroundColor: theme.palette.info[providerTier.color],
              color: theme.palette.secondary[providerTier.textColor]
            })}
          ></Chip>
        </Link>
      )
    }
    return <></>
  })

  return (
    <Box display="flex" flexDirection="row" gap={(theme) => theme.spacing(theme.tokens.spacing.xs)}>
      <ProviderTypeTags parentIds={parentIds} providerTypeIds={providerTypeIds} benefit={benefit} />
      <Stack
        direction="row"
        spacing="0"
        gap={(theme) => `${theme.spacing(theme.tokens.spacing.xs)} ${theme.spacing(theme.tokens.spacing.xxs)}`}
        sx={(theme) => ({ marginBottom: theme.spacing(theme.tokens.spacing.sm) })}
      >
        {providerTierTags}
      </Stack>
      <TierInfoModal open={open} onClose={() => setOpen(false)} tierForModal={tierForModal} benefit={benefit} />
    </Box>
  )
}
